<template>
  <div class="chart-container">
    <b-card class="lead-time-card">
      <b-card-header>
        <b-card-title>Lead Time Analysis for Completed Job Cards</b-card-title>
      </b-card-header>
      <apexcharts 
        ref="chart" 
        height="350" 
        type="bar" 
        :options="chartOptions" 
        :series="chartData.series" 
        @dataPointSelection="selectBar"
      ></apexcharts>
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";

export default {
  name: "LeadTimeChart",
  props: {
    leadTimeData: {
      type: Array,
      default: () => [],
    },
    jobCards: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    apexcharts: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
  },
  computed: {
    chartOptions() {
      return {
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text: "Lead Time (hours)",
          },
        },
        xaxis: {
          categories: this.chartData.dates,
          title: {
            text: "Date",
          },
          labels: {
            formatter: function(value) {
              return new Date(value).toLocaleDateString();
            }
          }
        },
        tooltip: {
          y: {
            formatter: function(value) {
              return value + " hours";
            }
          },
          x: {
            formatter: function(value) {
              return new Date(value).toLocaleDateString();
            }
          }
        }
      };
    },
    chartData() {
      if (this.leadTimeData && this.leadTimeData.length > 0) {
        const dates = this.leadTimeData.map(item => item.date);
        const leadTimes = this.leadTimeData.map(item => item.leadTime);
        
        return {
          dates: dates,
          series: [{
            name: "Lead Time",
            data: leadTimes
          }]
        };
      }
      
      return {
        dates: ["No Data Available"],
        series: [{
          name: "Lead Time",
          data: [0]
        }]
      };
    }
  },
  methods: {
    selectBar(event, chartContext, config) {
      const selectedIndex = config.dataPointIndex;
      const selectedDate = this.chartData.dates[selectedIndex];
      console.log("Selected date:", selectedDate);
      
      const filteredJobCards = this.jobCards.filter(card => {
        const cardDate = new Date(card.createdOn).toDateString();
        const selectedDateStr = new Date(selectedDate).toDateString();
        return cardDate === selectedDateStr;
      });
      
      if (filteredJobCards.length > 0) {
        this.$router.push({ 
          name: "jobcard-list-date", 
          query: { date: new Date(selectedDate).toISOString().split('T')[0] } 
        });
      }
    }
  },
  watch: {
    leadTimeData: {
      handler(newData) {
        console.log("Lead time data updated:", newData);
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style scoped>
.lead-time-card {
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>